import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function fetchAddOn(query){
    const queryString = serviceHelper.queryString(query);
    const addOnResponse = await axios.get(`config/add_on/get?${queryString}`, { withCredentials : true });
    return addOnResponse?.data;
}

async function fetchAddOnType(query){
    const queryString = serviceHelper.queryString(query);
    const addOnTypeResponse = await axios.get(`config/add_on/type/get?${queryString}`, { withCredentials : true });
    return addOnTypeResponse?.data;
}

async function fetchAddOnSection(query){
    const queryString = serviceHelper.queryString(query);
    const addOnSectionResponse = await axios?.get(`config/add_on/section/get?${queryString}`, { withCredentials : true, });
    return addOnSectionResponse?.data;
}

async function saveAddOn(params){
    const { image, name, description, add_on_type_id, add_on_section_id, reference_quantity, } = params ?? {};
    const formData = new FormData();
    formData.append('name', name);
    image && formData.append('image', image);
    description && formData.append("description", description);
    add_on_type_id && formData.append('add_on_type_id', add_on_type_id);
    add_on_section_id && formData.append('add_on_section_id', add_on_section_id);
    reference_quantity && formData.append('reference_quantity', reference_quantity);

    const saveAddOnResponse = await axios.post(`config/add_on/save`, formData, { withCredentials : true, headers : { "Content-Type": "multipart/form-data" }});
    return saveAddOnResponse?.data;
}

async function updateAddOn(add_on_id, params){
    const { image, name, description, add_on_type_id, add_on_section_id, is_delete_image, reference_quantity, } = params ?? {};
    const formData = new FormData();
    formData.append('name', name);
    image && formData.append('image', image);
    description && formData.append("description", description);
    add_on_type_id && formData.append('add_on_type_id', add_on_type_id);
    is_delete_image && formData?.append('is_delete_image', (is_delete_image === true ? 1 : 0));
    // melon/section
    add_on_section_id && formData.append('add_on_section_id', add_on_section_id);
    reference_quantity && formData.append('reference_quantity', reference_quantity);

    const updateAddOnResponse = await axios.post(`config/add_on/${add_on_id}/update`, formData, { withCredentials : true, headers : { "Content-Type": "multipart/form-data" }});
    return updateAddOnResponse?.data;
}

async function deleteAddOn(add_on_id){
    const deleteAddOnResponse = await axios.delete(`config/add_on/${add_on_id}/delete`, { withCredentials : true, });
    return deleteAddOnResponse?.data;
}

export default {
    fetchAddOn,
    fetchAddOnType,
    fetchAddOnSection,
    saveAddOn,
    updateAddOn,
    deleteAddOn,
}